import { colors } from '../../colors';
var header = {
  primaryColor: colors.onyx,
  hoverColor: colors.cerulean,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.onyx,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.onyx,
  navUtilityLinkHoverColor: colors.onyx,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '16px'
};
export default header;